import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class FramesetSchemaPlugin extends SchemaPlugin {
  nodes = {
    frameset: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'frameset',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      // Render frameset as mc-lwe-frameset because its width is always the width of the viewport which is too wide for the editor
      editorTagName: 'mc-lwe-frameset'
    },

    frame: {
      group: 'inline',
      content: 'inline*',
      inline: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'frame',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      editorTagName: 'mc-lwe-frame',
      isTagNameBox: true,
      atom: true,
      isVoid: true
    },

    noframes: {
      group: 'block',
      content: 'block+',
      defining: true, // Persist and wrap the inserted content during replace operations
      fillIfContentDeleted: 'mcCentralContainer',
      parseDOM: [{
        tag: 'noframes'
      }],
      toDOM(node) { return nodeToDOM(node); },
      // Render noframes as mc-lwe-noframes since it normally wouldn't be rendered by the browser
      editorTagName: 'mc-lwe-noframes'
    }
  } satisfies Record<string, NodeSpec>;
}
